import { BaseComponent } from '../base/base.component';
import { SharedModule } from '@shared/module/shared.module';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import type { IFollowStateData } from './pipe/follow-user-data.pipe';

import { RouterLink } from '@angular/router';
import { FollowResultHandlerService } from '@shared/service/state_services/follow-result-handler.service';

@Component({
    selector: 'app-follow-btn',
    templateUrl: './follow-btn.component.html',
    styleUrls: ['./follow-btn.component.scss'],
    imports: [
        SharedModule,
        RouterLink
    ]
})
export class FollowBtnComponent extends BaseComponent implements OnInit {
  private followResultService = inject(FollowResultHandlerService);
  private cdr = inject(ChangeDetectorRef);

  @Input() user!: IFollowStateData;
  @Input() customHeight!: string;
  @Output() onProfile: EventEmitter<void> = new EventEmitter<void>()


  @Output() Follow: EventEmitter<IFollowStateData> = new EventEmitter<IFollowStateData>();

  isProfileOwner!: boolean;

  followState = FollowStateEnum;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.user!.followBack = this.user?.followState === FollowStateEnum.OneWayThem;
  }

  followClicked() {
    // ? set new Ref to result service
    this.followResultService.setComponentRef(this);
    this.Follow.emit(this.user);
  }

  setNewState(result: FollowStateEnum) {
    if (result == FollowStateEnum.NoThing || result == FollowStateEnum.OneWayThem || result == FollowStateEnum.NotFollowed) {
      this.user.buttonClass = 'btn-sm';
      this.user.followStateText = 'دنبال کردن';
      this.user.followState = FollowStateEnum.NotFollowed;
    }
    else if (result == FollowStateEnum.OneWayYou || result == FollowStateEnum.TwoWay) {
      this.user.buttonClass = 'btn-sm';
      this.user.followStateText = 'دنبال شده';
      this.user.followState = FollowStateEnum.OneWayYou;
    }
    else if (result == FollowStateEnum.Requested) {
      this.user.buttonClass = 'btn-sm';
      this.user.followStateText = 'درانتظار تایید';
      this.user.followState = FollowStateEnum.Requested;
    }
    this.cdr.detectChanges();
  }

  navigateToProfile() {
    this.onProfile.emit();
  }

}
